import * as React from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';

const Pagination = ({ className, ...props }: React.ComponentProps<'nav'>) => (
  <nav
    role="navigation"
    aria-label="pagination"
    className={cn('mx-auto flex w-full justify-start', className)}
    {...props}
  />
);
Pagination.displayName = 'Pagination';

const PaginationContent = React.forwardRef<
  HTMLUListElement,
  React.ComponentProps<'ul'>
>(({ className, ...props }, ref) => (
  <ul
    ref={ref}
    className={cn('flex w-full flex-row items-center gap-0.5', className)}
    {...props}
  />
));
PaginationContent.displayName = 'PaginationContent';

const PaginationItem = React.forwardRef<
  HTMLLIElement,
  React.ComponentProps<'li'> & { isActive?: boolean }
>(({ className, isActive, ...props }, ref) => (
  <li
    ref={ref}
    className={cn(
      'text-text600 bg-bgColor15 hover:bg-back200 hover:text-text400 flex h-12 flex-shrink basis-[48px] cursor-pointer items-center justify-center text-sm',
      {
        'bg-back600': isActive,
      },
      className
    )}
    {...props}
  />
));
PaginationItem.displayName = 'PaginationItem';

const PaginationEllipsis = ({
  className,
  ...props
}: React.ComponentProps<'span'>) => (
  <span
    aria-hidden
    className={cn('flex h-9 w-9 items-center justify-center', className)}
    {...props}
  >
    ...
  </span>
);
PaginationEllipsis.displayName = 'PaginationEllipsis';

export { Pagination, PaginationContent, PaginationEllipsis, PaginationItem };
